import { StatusClassNames } from "../types/StatusClassNames";
export default function initMenuToggle() {
    var button = document.querySelector('.side-nav__btn');
    var nav = document.querySelector('.side-nav');
    if (!nav || !button) {
        return;
    }
    button.addEventListener('click', function () { return nav.classList.toggle(StatusClassNames.active); });
}
